import React from 'react';
import { Box, Select, MenuItem, Button, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';

interface QnaListOrderingProps {
  ordering: 'newest' | 'oldest';
  onOrderingChange: (ordering: 'newest' | 'oldest') => void;
  onDeleteAll: () => void;
  disableDeleteAll?: boolean;
  isFiltered?: boolean;
  filteredCount?: number;
}

const QnaListOrdering: React.FC<QnaListOrderingProps> = ({
  ordering,
  onOrderingChange,
  onDeleteAll,
  disableDeleteAll = false,
  isFiltered = false,
  filteredCount = 0,
}) => {
  const handleOrderingChange = (event: SelectChangeEvent<'newest' | 'oldest'>) => {
    const value = event.target.value as 'newest' | 'oldest';
    onOrderingChange(value);
  };


  return (
    <Box display="flex" alignItems="center" gap={2}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel id="ordering-select-label">Order By</InputLabel>
        <Select
          labelId="ordering-select-label"
          id="ordering-select"
          value={ordering}
          onChange={handleOrderingChange}
          label="Order By"
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 200,
              },
            },
          }}
        >
          <MenuItem value="newest">Newest</MenuItem>
          <MenuItem value="oldest">Oldest</MenuItem>
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="error"
        onClick={onDeleteAll}
        disabled={disableDeleteAll}
      >
        {isFiltered ? `Delete ${filteredCount} Filtered Q&A Pairs` : 'Delete All Q&A Pairs'}
      </Button>
    </Box>
  );
};

export default QnaListOrdering;
